








































import Vue from 'vue';
import scheduleClient from '../../apis';

export default Vue.extend({
  props: {
    ruleId: {
      type: Number,
      default: null,
    },
    showRuleName: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      size: 100,
      options2: {},
      data: [],
      loading: false,
      loaded: false,
    };
  },
  methods: {
    recordStatus(record: any) {
      switch (record.status) {
        case 0:
          return '等待中';
        case 1:
          return '发送中';
        case 2:
          return '已完成';
        default:
          return '等待中';
      }
    },
    getRecords() {
      this.loading = true;
      scheduleClient.getRecords({
        ruleId: this.ruleId,
        size: this.size}).success((r) => {
        this.loaded = true;
        this.loading = false;
        this.data = r;
      });
    },
  },
  mounted() {
    this.getRecords();
  },
});
